import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveDynamicComponent as _resolveDynamicComponent, createVNode as _createVNode } from "vue"

import * as BiTmplDetail_101_s from './components';


export default /*#__PURE__*/_defineComponent({
  __name: 'bi-tmpl-detail-101',
  props: ['disabled'],
  setup(__props) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    (_openBlock(), _createElementBlock(_Fragment, null, _renderList(BiTmplDetail_101_s, (item) => {
      return _createVNode(_resolveDynamicComponent(item), {
        key: item.name,
        disabled: __props.disabled
      }, null, 8, ["disabled"])
    }), 64))
  ]))
}
}

})